/**
 * Segments PDL éligibles (courbe + profils pointe, équivalents métier C5 / C4 / C2).
 * Aligné sur homeys-front `optimisation-contractuelle.vue`.
 */
export const OPTIM_TURPE_ELIGIBLE_SEGMENTS = [
    "C5",
    "C4",
    "C2",
    "P4",
    "P3",
    "P1",
] as const

/** Template optimturpe_C5 : segment compteur C5 ou P4. */
export function isOptimTurpeTemplateC5(segment: string): boolean {
    return segment === "C5" || segment === "P4"
}

/** Template optimturpe_C4 : segment C4 ou P3. */
export function isOptimTurpeTemplateC4(segment: string): boolean {
    return segment === "C4" || segment === "P3"
}

/** Template optimturpe_C2 : segment C2 ou P1. */
export function isOptimTurpeTemplateC2(segment: string): boolean {
    return segment === "C2" || segment === "P1"
}

/**
 * Filtres tableau dashboard : libellés C5/C4/C2, segments Enedis P4/P3/P1 regroupés (legacy).
 */
export const OPTIM_TURPE_DASHBOARD_SEGMENT_FILTER_GROUPS: Record<
    string,
    string[]
> = {
    C5: ["C5", "P4"],
    C4: ["C4", "P3"],
    C2: ["C2", "P1"],
}

/** Statut d’analyse considéré comme succès pour le tableau dashboard (legacy `STATUS.SUCCESS`). */
export const OPTIM_TURPE_DASHBOARD_ANALYSIS_SUCCESS = "SUCCESS"

export function isOptimTurpeEligibleSegment(segment: string): boolean {
    return (OPTIM_TURPE_ELIGIBLE_SEGMENTS as readonly string[]).includes(
        segment
    )
}
